import config from "@/config";
import http from "@/utils/request";

export default {
	users: {
		url: `${config.MAIN_URL}/admin/api/user`,
		name: "账号",
		put: async function (params) {
			return await http.put(this.url, params);
		},
	},
	userInfo: {
		url: `${config.MAIN_URL}/admin/api/user-msg`,
		name: "获取当前用户信息",
		get: async function () {
			return await http.get(this.url);
		},
	}
}
